<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"600px"'
    :cpntTitulo='(cpntParcela.tipo === "antecipar" ? "Antecipar" : "Reprocessar") + " Pagamento"'

    :cpntOnFecharDialog='cpntOnFecharDialog'>
    <template slot='conteudo'>
      <div class="config-meus-pagamento-cobrar">
        <span style="font-weight: 600; font-size: var(--font-base-soma-16); text-decoration: underline;">Atenção</span>
        <br/>
        <br/>

        Para realizar {{ cpntParcela.tipo === 'antecipar' ? 'a antecipação' : 'o reprocessamento' }} da parcela abaixo:
        <br/>

        <table>
          <tr>
            <td>Vencimento</td>
            <td>Valor</td>
            <td>Tipo de pagamento</td>
          </tr>
          <tr>
            <td>{{ cpntParcela.vencimento }}</td>
            <td>R$ {{ cpntParcela.valor }}</td>
            <td>{{ cpntParcela.forma }}</td>
          </tr>
        </table>

        É necessario informar a senha de acesso do usuário <u>{{ $store.state.token.conta }}</u>
        <br/>
        
        <div v-if="Object.keys(formulario).length >= 1" class="config-meus-pagamento-cobrar-form">
          <RF-Formulario :data-time='time'
            :cpntTime='time'

            :cpntId='formulario.id' 
            :cpntStatus='formulario.status'
            :cpntField='formulario.field'
            :cpntButtons='formulario.buttons'
            :cpntUltAlt='formulario.ult_alt'
            :cpntTabIndexFieldGeral='formulario.tabIndexFieldGeral'
            :cpntTabIndexButtonGeral='formulario.tabIndexButtonGeral'

            :ref='formulario.id'
          ></RF-Formulario>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.config-meus-pagamento-cobrar {
  text-align: center;
}
  .config-meus-pagamento-cobrar > table {
    width: 100%;
    margin: 20px 0px;
  }
    .config-meus-pagamento-cobrar > table > tr:first-child {
      background-color: #f4f9fe;
      text-decoration: none;
      border-top: 1px solid #d5dee5;
      border-bottom: 1px solid #d5dee5;
    }
      .config-meus-pagamento-cobrar > table > tr:first-child > td {
        padding: 5px;
        border-radius: 2px;
        color: #3875A5;
        font-weight: 600;
        text-align: center;
        border-right: 1px solid #d5dee5;
        border-left: 1px solid #d5dee5;
      }
    .config-meus-pagamento-cobrar > table > tr:not(:first-child) {
      background: #fff;
      text-decoration: none;
      border-top: 1px solid #d5dee5;
      border-bottom: 1px solid #d5dee5;
    }
      .config-meus-pagamento-cobrar > table > tr:not(:first-child) > td {
        padding: 1px 4px;
        height: 25px;
        color: var(--color-base-02);
        text-align: center;
        border-right: 1px solid #d5dee5;
        border-left: 1px solid #d5dee5;
      }
  .config-meus-pagamento-cobrar-form {
    margin-top: 30px;
    text-align: center;
  }
</style>

<style>
  .config-meus-pagamento-cobrar-form > div > .rf-form ~ div {
    width: 100%;
    max-width: none;
  }
  .config-meus-pagamento-cobrar-form > div > .rf-form > div > input {
    border: 1px solid #ccc;
    border-radius: 5px;
  }
</style>

<script>
  export default {
    props: {
      cpntParcela: {
        required: true
      },
      cpntOnFecharDialog: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {}
      }
    },
    mounted: function () {
      this.configMeusPagamentosCobrarPagIniciar()
    },
    methods: {
      configMeusPagamentosCobrarPagIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.configMeusPagamentosCobrarStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA CRIAR O FORMULARIO
        this.configMeusPagamentosCobrarFormularioIniciar()
      },
      configMeusPagamentosCobrarStatusGeral: function (status) {
        // SETA O STATUS GERAL DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      configMeusPagamentosCobrarFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: '',
          id: 'config-meus-pagamento-cobrar',
          field: {}
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA PARA DIGITAR O PRODUTO
        self.formulario.field = {
          senha: {
            tamanho: 2,
            tipo: 'input',
            type: 'password',
            nome: 'Senha',
            value: '',
            onChange: self.configMeusPagamentosCobrarOnChange
          }
        }

        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA OS BOTÕES DO FORMULARIO
          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            env: self.configMeusPagamentosCobrarSalvar,
            can: self.cpntOnFecharDialog
          }, function (buttons) {
            buttons.env.texto = self.cpntParcela.tipo === 'antecipar' ? 'Antecipar' : 'Reprocessar'

            // CRIA OS BUTTONS DO FORMULARIO
            self.formulario.buttons = buttons

            // SETA O STATUS PARA O FORMULARIO
            self.formulario.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // SETA O STATUS DA PAGINA
            self.configMeusPagamentosCobrarStatusGeral('')

            // SETA O FOCUS NO NOVO CAMPO
            self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'senha', false)
          })
        })
      },
      configMeusPagamentosCobrarOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.formulario.id.length + 1), id.length)

        // SETA O VALOR ATUALIZADO RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      configMeusPagamentosCobrarSalvar: function () {
        var self = this

        // SETA O STATUS DO BUTTON
        self.formulario.buttons.env.status = 'carregando'
        self.formulario.buttons.can.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // INICIA A FORMULARIO PARA ENVIO API
        var formData = { cod_fin: self.cpntParcela.id, senha: self.formulario.field.senha.value }

        self.$store.state.comunicaAPI('/subase/financeiro/' + self.cpntParcela.tipo, 'PUT', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            self.cpntOnFecharDialog(true)
          })
        }, function () {
          self.cpntOnFecharDialog(true)
        }, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (field) {
            // SETA OS CAMPOS COM OS ERROS
            self.formulario.field = field

            // SETA O STATUS DO BUTTON
            self.formulario.buttons.env.status = ''
            self.formulario.buttons.can.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA FECHAR
            self.cpntOnFecharDialog(true)
          })
        })
      }
    }
  }
</script>
